// extracted by mini-css-extract-plugin
module.exports = {"textCenter":"style_textCenter__tuYdS","paywatchDescription":"style_paywatchDescription__V_7PR"};